$(document).ready(() => {
  $(document).on('change', '.toggle_cover_sheet', toggleCoverSheet);
  let timer;
  function toggleCoverSheet() {
    const _this = this;
    const checkBoxState = this.checked;
    const pdfId = this.getAttribute('id');
    const companyId = this.getAttribute('company_id');

    clearTimeout(timer);

    // Build form data
    const data = {
      cover_sheet_selection: {
        selected: checkBoxState,
        attachment_id: pdfId,
      },
    };

    // Uncheck other boxes
    $('.toggle_cover_sheet').each((x, checkBox) => {
      if (checkBox !== _this) {
        checkBox.checked = false;
      }
    });

    timer = setTimeout(() => {
      // Update db
      $.ajax({
        type: 'PUT',
        url: '/companies/' + companyId + '/cover_sheet_selection',
        data,
      });
    }, 600);
  }
});
